/* Copyright 2013 - 2024 Waiterio LLC */
import throttle from './throttle.js'

export default function debounce(delay, atBegin, callback) {
  return callback === undefined
    ? throttle(delay, atBegin, false)
    : throttle(delay, callback, atBegin !== false)
}
